import React, { useState } from "react";
import { auth, db } from "./firebase";
import { doc, updateDoc, setDoc } from "firebase/firestore";
import "./PaymentPage.css";

const PaymentPage = () => {
  const [txnId, setTxnId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!txnId) return alert("Please enter your Transaction ID.");

    try {
      setSubmitting(true);
      const user = auth.currentUser;
      if (!user) {
        alert("You need to be logged in to submit payment proof.");
        return;
      }
      // ✅ define userRef here
      const userRef = doc(db, "users", user.uid);
      // 1. Save to Firestore
      await setDoc(
        userRef,
        {
          paymentTxnId: txnId,
          paymentStatus: "pending",
        },
        { merge: true } // 👈 ensures it creates the doc if it doesn't exist
      );

      // 2. Send email to TravXplo Gmail using Formspree
      await fetch("https://formspree.io/f/myzdbyvw", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: user.displayName || "User",
          email: user.email,
          transaction_id: txnId,
        }),
      });

      alert(
        "✅ Transaction ID submitted! Your plan will be shortly activated after verification."
      );
      // window.location.href = "/AIItinerary";
      setTxnId("");
    } catch (err) {
      console.error(err);
      alert("❌ Error submitting transaction. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="payment-page">
      <h2>Pay via UPI</h2>
      <div className="qr-container">
        <img src="/upi-qr.png" alt="UPI QR" className="qr-code" />
      </div>

      <form onSubmit={handleSubmit}>
        <label>Enter Transaction ID (from UPI app):</label>
        <input
          type="text"
          value={txnId}
          onChange={(e) => setTxnId(e.target.value)}
          placeholder="Eg: 324567891234"
        />
        <button class="btn" type="submit" disabled={submitting}>
          {submitting ? "Submitting..." : "Submit Transaction"}
        </button>
      </form>

      <p className="note">
        ⚡ Once you submit your Transaction ID, our team will verify it and
        activate your plan (usually within 1 hour).
      </p>
    </div>
  );
};

export default PaymentPage;
